/**
 * Converts a string to a URL-friendly slug
 * @param {string} text - The text to convert to a slug
 * @returns {string} - The URL-friendly slug
 */
export const generateSlug = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '')        // Remove all non-word chars except hyphens
    .replace(/-+/g, '-')           // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '')             // Trim hyphens from start
    .replace(/-+$/, '');            // Trim hyphens from end
};

/**
 * Finds a blog by slug from an array of blogs
 * @param {Array} blogs - Array of blog objects
 * @param {string} slug - The slug to search for
 * @returns {Object|null} - The matching blog object or null
 */
export const findBlogBySlug = (blogs, slug) => {
  return blogs.find(blog => {
    const blogSlug = blog.slug || generateSlug(blog.title);
    return blogSlug === slug;
  });
};

